import { paths } from '@/config/paths';
import { QueryClient } from '@tanstack/react-query';
import { createBrowserRouter, Outlet } from 'react-router-dom';
import AppLayout from '../components/layouts/AppLayout';
import { AdminRoute } from './AdminRoute';
import { ProtectedRoute } from './ProtectedRoute';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const convert = (queryClient: QueryClient) => (m: any) => {
  const { clientLoader, clientAction, default: Component, ...rest } = m;
  return {
    ...rest,
    loader: clientLoader?.(queryClient),
    action: clientAction?.(queryClient),
    Component,
  };
};

export const createAppRouter = (queryClient: QueryClient) =>
  createBrowserRouter([
    {
      path: paths.auth.root.path,
      lazy: () => import('./auth/index').then(convert(queryClient)),
    },
    {
      path: paths.app.root.path,
      element: (
        <ProtectedRoute>
          <AppLayout>
            <Outlet />
          </AppLayout>
        </ProtectedRoute>
      ),
      // ErrorBoundary: MainErrorFallback,
      children: [
        {
          path: paths.app.dashboard.path,
          lazy: () => import('./dashboard').then(convert(queryClient)),
        },
        {
          path: paths.app.user.path,
          lazy: () => import('./users').then(convert(queryClient)),
        },
        {
          path: paths.app.workflow.path,
          lazy: () => import('./workflows').then(convert(queryClient)),
        },
        {
          path: paths.app.schedule.path,
          lazy: () => import('./schedules').then(convert(queryClient)),
        },
        {
          path: paths.app.execution.path,
          lazy: () => import('./executions').then(convert(queryClient)),
        },
        {
          path: paths.app.settings.path,
          lazy: () => import('./settings').then(convert(queryClient)),
        },
        {
          path: paths.app.admin.path,
          element: (
            <AdminRoute>
              <Outlet />
            </AdminRoute>
          ),
          children: [
            {
              path: '',
              lazy: () => import('./admin').then(convert(queryClient)),
            },
          ],
        },
      ],
    },
  ]);
